@if (signature) {
  <div class="signature">
    <span class="name">{{ signature | dataRowFieldValuePipe: 'fullName' }}</span>
    <span class="date">{{
      signature
        | dataRowFieldValuePipe: 'signedDate'
        | formatValue: 'date' : { dateFormat: 'MM/dd/yyyy' }
    }}</span>
  </div>
}
